export class RefractorAutoDetect {
  constructor() {
    this.modes = []
    this.supportedModes = {
      markup: [
        'xml|rdf|rss|wsdl|xslt|atom|mathml|mml|xul|xbl|xaml|plist|xsd|dtd|xsl|resx|iml|xquery|tmLanguage|manifest|project|html|htm|xhtml|vue|we|wpy'
      ],
      css: ['css'],
      clike: ['ceylon|nut'],
      javascript: ['js|jsm|ejs|esx'],
      abap: ['abap'],
      actionscript: ['as'],
      ada: ['ada|adb'],
      apacheconf: ['^htaccess|^htgroups|^htpasswd|^conf|htaccess|htgroups|htpasswd'],
      apl: ['apl'],
      applescript: ['applescript'],
      arduino: ['ino'],
      arff: ['arff'],
      asciidoc: ['asciidoc|adoc'],
      asm6502: ['asm6502'],
      aspnet: ['asp|cshtml'],
      autohotkey: ['ahk'],
      autoit: ['au3'],
      bash: ['bash|zsh|tcsh|csh|ksh|sh'],
      basic: ['b'],
      batch: ['bat|cmd'],
      brainfuck: ['bf'],
      bro: ['bro'],
      c: ['c|cc|cxx|h|hh|hpp|ino'],
      csharp: ['cs'],
      cpp: ['mm|cpp'],
      coffeescript: ['coffee|cf|cson|^Cakefile'],
      clojure: ['clj|cljs'],
      crystal: ['cr'],
      csp: ['csp'],
      d: ['d'],
      dart: ['dart'],
      diff: ['diff|patch'],
      docker: ['dockerfile|dockerignore|^Dockerfile'],
      eiffel: ['e|ge'],
      elixir: ['ex|exs'],
      elm: ['elm'],
      erb: ['erb|rhtml|html.erb'],
      erlang: ['erl|hrl'],
      fsharp: ['fsi|fs|ml|mli|fsx|fsscript'],
      fortran: ['f|f90'],
      gedcom: [],
      gherkin: ['feature'],
      git: ['gitignore|gitconfig|gitattributes|gitmodules|gitkeep|git-history'],
      glsl: ['glsl|frag|vert'],
      go: ['go'],
      graphql: ['graphql|gql'],
      groovy: ['groovy'],
      haml: ['haml'],
      handlebars: ['hbs|handlebars|tpl|mustache'],
      haskell: ['hs|cabal'],
      haxe: ['hx'],
      http: ['http'],
      inform7: ['i7x'],
      ini: ['ini|conf|cfg|prefs|dlc|dll'],
      io: ['io'],
      java: ['java|jar|jsp'],
      jolie: [],
      json: ['json'],
      julia: ['jl'],
      keyman: ['kmn'],
      kotlin: ['kt|kts'],
      latex: ['tex|latex|ltx|bib'],
      less: ['less'],
      liquid: ['liquid'],
      lisp: ['lisp'],
      livescript: ['ls'],
      lolcode: ['lol|lols'],
      lua: ['lua'],
      makefile: ['^Makefile|^GNUmakefile|^makefile|^OCamlMakefile|make'],
      markdown: ['md|markdown|rst'],
      matlab: ['matlab'],
      mel: ['mel'],
      mizar: ['miz|voc'],
      nasm: ['asm|a51|inc|nasm|s|ms|agc|ags|aea|argus|mitigus|binsource'],
      nim: ['nim|nimble'],
      nix: ['nix'],
      nsis: ['nsi|nsh'],
      objectivec: ['m|mm'],
      ocaml: ['ml|mli|cmx'],
      opencl: ['cl'],
      pascal: ['pas|p'],
      perl: ['pl|pm'],
      php: ['php|phtml|shtml|php3|php4|php5|phps|phpt|aw|ctp|module'],
      phpExtras: [],
      plsql: ['pgsql'],
      powershell: ['ps1|psm1|psd1|ps1xml|psc1|pssc'],
      processing: [],
      prolog: ['plg|prolog'],
      properties: ['properties'],
      protobuf: ['proto'],
      pug: ['jade|pug'],
      puppet: ['epp|pp'],
      pure: ['pure'],
      python: ['py'],
      qore: ['q|qm|qtest'],
      r: ['r'],
      jsx: ['jsx'],
      tsx: ['tsx'],
      reason: ['re|rei'],
      rest: ['rest'],
      roboconf: ['roboconf'],
      ruby: ['rb|ru|gemspec|erb|rake|^Guardfile|^Rakefile|^Gemfile'],
      rust: ['rs'],
      sass: ['sass'],
      scss: ['scss'],
      scala: ['scala'],
      scheme: ['scm|sm|rkt|oak|scheme'],
      smalltalk: [],
      smarty: ['smarty|tpl'],
      sql: ['sql|sqlserver|pdb|pks|pkb|accdb|mdb|sqlite'],
      soy: ['soy'],
      stylus: ['styl|stylus'],
      swift: ['swift'],
      tcl: ['tcl'],
      textile: ['textile'],
      twig: ['twig|swig'],
      typescript: ['ts|typescript|str'],
      velocity: ['vm'],
      verilog: ['v|vh|sv|svh'],
      vhdl: ['vhd|vhdl'],
      vim: ['vim'],
      'visual-basic': ['vbs|vb|suo|sln|csproj'],
      wasm: ['wat|wasm'],
      wiki: ['wiki'],
      yaml: ['yaml|yml'],
      abnf: ['abnf'],
      agda: ['agda'],
      al: ['al'],
      antlr4: ['g|g4'],
      apex: ['cls'],
      aql: [],
      asmatmel: [],
      avisynth: [],
      'avro-idl': ['avdl|avpr'],
      bbcode: [],
      bicep: ['bicep'],
      birb: [],
      bison: ['bison'],
      bnf: [],
      brightscript: ['brs'],
      bsl: ['bsl|os'],
      cfscript: ['cfc'],
      chaiscript: ['chai'],
      cil: ['cil'],
      cmake: ['cmake|cmake.in'],
      cobol: ['cob|cbl|ccp|cobol|cpy'],
      concurnas: ['conc'],
      coq: ['coq|q'],
      cshtml: ['cshtml|razor'],
      'css-extras': [],
      csv: ['csv'],
      cypher: [],
      dataweave: ['dwl'],
      dax: [],
      dhall: ['dhall'],
      django: ['jinja|j2|jinja2'],
      'dns-zone-file': ['zone'],
      dot: ['dot|gv'],
      ebnf: ['ebnf'],
      editorconfig: ['editorconfig'],
      ejs: ['ejs|ect|ejs.t|jst'],
      etlua: ['etlua'],
      'excel-formula': [],
      factor: ['factor|factor-boot-rc|factor-rc'],
      false: [],
      'firestore-security-rules': ['firestore.rules'],
      flow: [],
      ftl: ['ftl'],
      gap: ['g|gap|gd|gi|tst'],
      gcode: ['gcode|gco|cnc|g'],
      gdscript: ['gd'],
      gml: ['gml'],
      gn: ['gn|gni'],
      'go-module': ['go.mod'],
      hcl: ['hcl|nomad|tf|tfvars|workflow'],
      hlsl: ['hlsl|cginc|fx|fxh|hlsli'],
      hoon: ['hoon'],
      hpkp: [],
      hsts: [],
      ichigojam: [],
      icon: [],
      'icu-message-format': [],
      idris: ['idr|lidr'],
      iecst: [],
      ignore: ['^gitignore'],
      j: ['ijs'],
      javadoc: [],
      javadoclike: [],
      javastacktrace: [],
      jexl: [],
      jq: ['jq'],
      'js-extras': [],
      'js-templates': ['jst'],
      jsdoc: ['jsdoc'],
      json5: ['json5'],
      jsonp: ['jsonp'],
      jsstacktrace: [],
      keepalived: ['keepalived.conf'],
      kumir: ['kum'],
      kusto: ['csl'],
      latte: ['latte'],
      lilypond: ['ly|ily'],
      llvm: ['ll'],
      log: ['log'],
      magma: [],
      'markup-templating': [],
      maxscript: ['ms|mcr'],
      mermaid: ['mmd'],
      mongodb: ['mongo|mongodb'],
      monkey: ['monkey|monkey2'],
      moonscript: ['moon'],
      n1ql: [],
      n4js: [],
      'nand2tetris-hdl': ['hdl'],
      naniscript: [],
      neon: ['neon'],
      nevod: [],
      nginx: ['nginx|nginxconf|vhost'],
      openqasm: ['qasm'],
      oz: ['oz'],
      parigp: [],
      parser: [],
      pascaligo: ['ligo'],
      pcaxis: [],
      peoplecode: [],
      'php-extras': [],
      phpdoc: [],
      powerquery: ['pq'],
      promql: [],
      psl: ['psl'],
      purebasic: ['pb|pbi'],
      purescript: ['purs'],
      q: ['q'],
      qml: ['qml|qbs'],
      qsharp: ['qs'],
      racket: ['rkt|rktd|rktl|scrbl'],
      regex: ['regexp|regex'],
      rego: ['rego'],
      renpy: ['rpy'],
      rip: ['rip'],
      robotframework: ['robot'],
      sas: ['sas'],
      'shell-session': ['sh-session'],
      smali: ['smali'],
      sml: ['sml|sig|fun|ml'],
      solidity: ['sol'],
      'solution-file': ['sln'],
      sparql: ['sparql|rq'],
      'splunk-spl': ['spl'],
      sqf: ['sqf|hqf'],
      squirrel: ['nut'],
      stan: ['stan'],
      systemd: ['^service|^socket|^device|^mount|^automount|^swap|^target|^path|^timer|^snapshot|^slice|^scope'],
      't4-cs': [],
      't4-templating': ['tt'],
      't4-vb': [],
      tap: [],
      toml: ['toml'],
      tremor: ['troy'],
      tt2: ['tt2'],
      turtle: ['ttl'],
      typoscript: ['typoscript'],
      unrealscript: ['uc'],
      uorazor: ['razor'],
      uri: [],
      v: ['v'],
      vala: ['vala|vapi'],
      vbnet: ['vb|vbhtml|vbs|vba|frx|frm|cls|bas|bi|rbbas|rbfrm|rbmnu|rbres|rbtbar|rbuistate|'],
      warpscript: [],
      'web-idl': ['webidl'],
      wolfram: ['mathematica|cdf|m|ma|mt|nb|nbp|wl|wlt'],
      wren: ['wren'],
      xeora: [],
      'xml-doc': ['xml'],
      xojo: ['xojo_code|xojo_menu|xojo_report|xojo_script|xojo_toolbar|xojo_window'],
      xquery: ['xquery|xq|xql|xqm|xqy'],
      yang: ['yang'],
      zig: ['zig']
    }
    this.modesByName = {}
    this.extRe = null
    for (const name in this.supportedModes) {
      const data = this.supportedModes[name]
      const displayName = name.replace(/_/g, ' ')
      const filename = name.toLowerCase()
      const mode = new Mode(displayName, data[0])
      this.modesByName[filename] = mode
      this.modes.push(mode)
    }
  }

  getSupportedModes = () => this.supportedModes

  getFileMode = path => {
    let mode = this.modesByName.text
    const fileName = path.split(/[\/\\]/).pop()
    for (let i = 0; i < this.modes.length; i++) {
      if (this.modes[i].supportsFile(fileName)) {
        mode = this.modes[i]
        break
      }
    }
    if (typeof mode === 'undefined') {
      return null
    }
    return mode.mode
  }
}

class Mode {
  constructor(mode, extensions) {
    this.mode = mode
    this.extensions = extensions
    let re
    if (/\^/.test(extensions)) {
      re = `${extensions.replace(/\|(\^)?/g, (a, b) => `$|${b ? '^' : '^.*\\.'}`)}$`
    } else {
      re = `^.*\\.(${extensions})$`
    }

    this.extRe = new RegExp(re, 'gi')
  }

  supportsFile = filename => filename.match(this.extRe)
}
